declare const mxUtils: any;
import {ShapeCommand} from '../commands.template';
import {FlowlineFormUtil} from '../../diagram-render/helpers/flowline-form.util';
import * as _ from 'lodash';
import {FlForm} from './flowline.commands';

export class FlowlineChangeformCommand extends ShapeCommand {
  private oldForm: any;
  private newForm: any;
  private withReset: boolean;
  private waypoints: any;

  protected services: any;

  constructor(data) {
    super(data);
  }

  public prepareData(newFormData: FlForm): this {
    const model = this.services.editorRegistrySvc.getGraph().getModel();

    this.oldForm = FlowlineFormUtil.newFormsItem(_.cloneDeep(this.object.flForm));
    this.newForm = FlowlineFormUtil.newFormsItem(newFormData);

    this.withReset = newFormData.resetPoints;
    this.waypoints = model.getCell(this.object.mxKey).getGeometry().clone().points;

    return this;
  }

  private changeForm(isReverse: boolean) {
    const formData = isReverse ? this.oldForm : this.newForm;

    const model = this.services.editorRegistrySvc.getGraph().getModel();

    const cell = model.getCell(this.object.mxKey);

    let styleString = cell.style;
    const geometry = cell.geometry.clone();
    const change = <any>{
      mxKey: Number(cell.id),
      flForm: formData
    };

    cell.skipUndo = true;
    model.beginUpdate();

    if (this.withReset) {
      const geo = geometry.clone();

      geo.points = isReverse ? this.waypoints : [];
      model.setGeometry(cell, geo);
      change.waypoints = geo.points;
    }

    const mxState = FlowlineFormUtil.get.mxState(formData) as any;

    for (const key in mxState) {
      styleString = mxUtils.setStyle(styleString, key, mxState[key]);
    }

    model.setStyle(cell, styleString);

    model.endUpdate();

    return this.services.diagramUpdateSvc.update({
      changeFlowline: change
    });
  }

  public execute() {
    super.execute();
    this.changeForm(false);
  }

  public reverse() {
    super.reverse();
    this.changeForm(true);
  }
}
